import { isSameDay } from './isSameDay';
export var isToday = function isToday(date) {
  var today = new Date();
  return isSameDay(today, new Date(date));
};